import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'update-component';
export function useSendUpdatedComponent() {
    const { postMessage } = useIframeMessageContext();
    const sendUpdatedComponent = useCallback((component) => {
        postMessage(MESSAGE_TYPE, component);
    }, [postMessage]);
    return { sendUpdatedComponent };
}
const handleMessage = (context, message) => {
    const { notifyComponentUpdate, replaceComponent } = context;
    if (message.body) {
        // the component coming from the main window needs to be mapped
        // to the iframe's site context components
        const component = message.body;
        // console.log('handleMessage received updated component', component);
        replaceComponent(component);
        notifyComponentUpdate(component);
    }
};
registerIframeMessageHook(MESSAGE_TYPE, useSendUpdatedComponent, handleMessage);
//# sourceMappingURL=useSendUpdateComponent.js.map